import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./components/Pages/Home";
import Partner from "./components/Pages/Partner";
import Investor from "./components/Pages/Investor";
import Business from "./components/Pages/Business";
import Career from "./components/Pages/Career";
import Safety from "./components/Pages/Safety";
import Contact from "./components/Pages/Contact";
import AboutUs from "./components/Pages/AboutUs";
import Blog from "./components/Pages/Blog";
import BlogPage from "./components/Pages/BlogPage";
import TermsAndConditions from "./components/Pages/TermsAndConditions";
import PrivacyPolicy from "./components/Pages/PrivacyPolicy";

export default function App() {

  const routes = [
    {
      path: "/home",
      element: <Home />,
    },
    {
      path: "/partners",
      element: <Partner />,
    },
    {
      path: "/investors",
      element: <Investor />,
    },
    {
      path: "/business",
      element: <Business />,
    },
    {
      path: "/careers",
      element: <Career />,
    },
    {
      path: "/safety",
      element: <Safety />,
    },
    {
      path: "/contact",
      element: <Contact />,
    },
    {
      path: "/about",
      element: <AboutUs />,
    },
    {
      path: "/blog",
      element: <Blog />,
    },
    {
      path: "/blogPage",
      element: <BlogPage />,
    },
    {
      path: "/privacy-policy",
      element: <PrivacyPolicy />,
    },
    {
      path: "/terms-and-conditions",
      element: <TermsAndConditions />,
    }
  ];

  return (
    <div className="container">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          {routes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
        </Routes>
      </BrowserRouter>
    </div>
  );
}
